/* istanbul ignore file */

export default {
  "privacy-policy": "https://www.vodafone.gr/vodafone-ellados/privacy-policy-cookies",
  "help-and-support": "https://www.vodafone.gr/ypostirixi/faqs/ypiresia-vodafone-tv",
  "cookie-preferences": "cookie-preferences",
  "terms-and-conditions": "https://www.vodafone.gr/vodafone-ellados/oroi-chrisis",
  accessibility: "accessibility",
};
